import { z } from "zod";

export const getContactSchema = () => {
  const t =
    (window as any).commonVariables?.translations?.contactForm?.validation ||
    {};

  return z
    .object({
      name: z.string().min(2, t.nameMin || "İsim çok kısa"),
      email: z
        .string()
        .email(t.emailInvalid || "Geçersiz e-posta")
        .or(z.literal("")),
      phone: z.string().optional(),
      message: z.string().min(10, t.messageMin || "Mesaj çok kısa"),
      nickname: z.string().optional(),
      form_load_timestamp: z.coerce.number(),
      recaptcha_token: z.string().optional(),
    })
    .superRefine((data, ctx) => {
      if (!data.email && !data.phone) {
        const errorMsg =
          t.phoneOrEmailRequired ||
          "Telefon numarası veya eposta bilgisi giriniz";
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: errorMsg,
          path: ["email"],
        });
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: errorMsg,
          path: ["phone"],
        });
      }
    });
};
